<template>
  <a-layout class="setEstimated">
    <a-row justify="space-between" type="flex" class="nhf-header">
      <h1 class="nhf-title">
        <img class="nhf-logo" :src="logo" alt="返回上一页面" />
        <span>{{ factoryName }}</span>
      </h1>
      <a-space>
        <a-button
          size="small"
          style="width: 64px; margin-bottom: 6px"
          type="primary"
          @click="goBack"
          >返回</a-button
        >
      </a-space>
    </a-row>
    <div style="display: flex">
      <estimate-information
        style="width: 40%; margin-right: 1%"
        @getId="getId"
        @getType="getType"
        :details="details"
        :details2="details2"
        :animalData="animalData"
        :estimateData="estimateData"
        :animalTypeId="animalTypeId"
        :feedProgramId="feedProgramId"
        :resEquationId="resEquationId"
      />
      <estimated-results
        ref="EstimatedResults"
        style="width: 59%"
        :details="details"
        :animalTypeId="animalTypeId"
      />
    </div>
  </a-layout>
</template>
<script>
import EstimateInformation from "./EstimateComponents/CopyComponents/EstimateInformation.vue";
import EstimatedResults from "./EstimateComponents/DetailsComponents/EstimatedResults.vue";
import { mapMutations,mapState } from "vuex";
import { getRequest } from "@/components/Common/Utils/Utils";
import logo from "@/assets/images/logo_nhf.svg"; //logo图

export default {
  components: { EstimateInformation, EstimatedResults },
  data() {
    return {
      details: {},
      estimateId: getRequest("id"),
      factoryName: window.localStorage.getItem("factoryName"), //工厂名称
      logo,
      animalData: {},
      estimateData: {}, //保存立即预估数据
      animalTypeId: "",
      feedProgramId: "",
      resEquationId: "",
      details2: {}
    };
  },
  mounted() {
    this.getInfor();
    // this.getFeedingProgramInfo();
    this.getAnimal();
  },
  computed: {
    ...mapState("economy", ["predictionType",]),
    ...mapState("estimate", ["dataDictionary",]),
  },
  // watch:{
  //   nhfEstimateData:{
  //     handler(){
  //       console.log('nhfEstimateData',this.nhfEstimateData)
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    ...mapMutations("estimate", ["setDataDictionary",'setSystemName','setState']),
    ...mapMutations("economy", ["setPredictionType","setAnimalTypeName"]),
    ...mapMutations("procedure", ["setProcedureDetail",]),
    //保存动物类型
    async getAnimal() {
      let res = await this.$http.get(
        `/nhf-app/formulaManage/detail?formulaId=${this.estimateId}`
      );
      let { success, data } = res;
      if (success) {
        this.animalData = { ...this.animalData, ...data };
        this.setAnimalTypeName(data.animalTypeName)
      }
    },

    //获取饲喂程序
    async getFeedingProgramInfo() {
      let formulaId = getRequest("id")
      if(!formulaId) return
      let srcData = JSON.parse(getRequest('params'))
      let {averageWeight,weightArr=[],day=[]} = srcData || {}
      let params= {
        formulaId,
        startWeight: weightArr[0] ? weightArr[0] : undefined,
        endWeight: weightArr[1] ? weightArr[1] : undefined,
        averageWeight: averageWeight ? averageWeight : undefined,
        startDay: day[0] ? day[0] : undefined,
        endDay: day[1] ? day[1] : undefined,
      }
      let res = await this.$http.get(`/sat-maximization/pigFeedingProgramInfo/getORCreatePigFeedingProgramInfoByFormulaId`,{params});
      let { success, data } = res;
      if (success) {
        this.setProcedureDetail(data) //保存饲喂程序详情
        this.getWeight(data.id)
        this.animalData = { ...this.animalData, ...data };
        let { platformEquations = [] } = data || {};
        let obj = platformEquations[0] || {};
        this.animalTypeId = data.animalTypeId;
        this.feedProgramId = data.id;
        if (obj.id) {
          this.resEquationId = obj.id;
          this.resetFields(obj.id);
        }
      }
    },

    getType(predictionTypeCode) {
      if(predictionTypeCode) this.$refs.EstimatedResults.init({ predictionTypeCode });
    },
    //点击立即预估，获取到预估结果的id
    getId(id) {
      this.$refs.EstimatedResults.init({ id});
    },
    getInfor() {
      let params = {
        code: "EnergySystem,AminoAcidSystem,PhosphorusSystem,genderOption,currentFeedIntakeOption,actualMeanIntakeOrIntakeCurve,observedMeanIntakeCurveType,CurrentPDPatternNumber,CurrentGrowthPerformanceNumber,EcoModel",
      };
      this.$get("/sat-maximization/dict/listDictByCode", params).then((res) => {
        let { success, data = [] } = res || {};
        if (success) {
          let arrField = {};
          data.forEach((el) => {
            arrField[el.code] = el.dictList || [];
          });
          this.setDataDictionary(arrField);
          setTimeout(() => {
            this.getFeedingProgramInfo();
          }, 0);
        }
      });
    },
    resetFields(id) {
      this.$http
        .get(
          `/sat-maximization/ipdefaultvalue/listByEquationId?equationId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            let { keyValue = "" } = data || {};
            let details = keyValue ? JSON.parse(keyValue) : {};
            this.details = details
            this.details2 = details
            let {prediction} = details || {}
            let {energySystem,phosphorusSystem,predictionType} = prediction || {}
            if(energySystem) this.getEnergyName({val:energySystem,field: 'energySystem'})
            if(phosphorusSystem) this.getEnergyName({val:phosphorusSystem,field: 'phosphorusSystem'})
            if(predictionType) this.getEnergyName({val:predictionType,field: 'predictionType'})

            this.setPredictionType(this.details.prediction.predictionType);
          }
        });
    },
    getEnergyName({val,field}){
      let name = ''
      let {EnergySystem=[],PhosphorusSystem=[],AminoAcidSystem=[]} = this.dataDictionary || {}
      let list = []
      if(field === 'energySystem'){
        list = EnergySystem
      }else if(field === 'aminoAcidSystem'){
        list = AminoAcidSystem
      }else if(field === 'phosphorusSystem'){
        list = PhosphorusSystem
      }
      if(list && list.length){
        let obj = list.find(el => el.dictKey === val) || {}
        name = obj.dictValue
      }
      if(name){
        // if(field === 'energySystem') this.$emit('getEnergySystemName',{name,energySystem: val})
        if(field === 'energySystem') this.setSystemName({name,code: val,field})
        if(field === 'phosphorusSystem') this.setSystemName({name,code: val,field})
        if(field === 'aminoAcidSystem') this.setSystemName({name,code: val,field})
      }
    },
    //存体重
    getWeight(id){
      console.log(123)
      this.$get('/sat-maximization/pigFeedingProgramInfo/pigFeedingProgramInfoWeight?id='+ id).then(res => {
        let {success,data} = res || {}
        if(success) {
          let {startWeight,endWeight} = data || {}
          let weightData = { min: startWeight, max: endWeight };
          this.setState({weightData})
        }
      })
    },

    //返回上一级
    goBack() {
      // this.$router.go(-1);
      this.$router.push("/nhf-compound-editor?id="+getRequest("id"))
    },
  },
};
</script>
<style lang="scss" scoped>
.nhf-logo {
  // width: 80px;
  height: 23px;
  margin-right: 8px;
}
.setEstimated {
  padding: 6px 20px;
  min-height: 100vh;

  .nhf-header {
    padding: 10px 0 0;
  }
}
.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
  font-size: 14px;
  font-weight: bold;
}
</style>